import { call, put, takeEvery } from 'redux-saga/effects';
import { createContactAPI, deleteContactAPI, getContactAPI, updateContactAPI } from "../Services"
import { ADD_CONTACT, ADD_CONTACT_RED, DELETE_CONTACT, DELETE_CONTACT_RED, GET_CONTACT, GET_CONTACT_RED, UPDATE_CONTACT, UPDATE_CONTACT_RED } from "../Constant"

// / Create Notifaction Saga
function* createContactSaga(action) {
    try {
        const response = yield call(createContactAPI, action.payload);
        if (response && response.data) {
            yield put({ type: ADD_CONTACT_RED, data: response.data });
        } else {
            console.error("Create Contact API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in createContactSaga:", error);
    }
}

// Get Notifaction Saga
function* getContactSaga() {
    try {
        const response = yield call(getContactAPI);
        if (response && response.data) {
            yield put({ type: GET_CONTACT_RED, data: response.data });
        } else {
            console.error("Get Contact API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in getContactSaga:", error);
    }
}

// Delete Notifaction Saga
function* deleteContactSaga(action) {
    try {
        const response = yield call(deleteContactAPI, action.payload);
        if (response) {
            yield put({ type: DELETE_CONTACT_RED, data: action.payload });
        } else {
            console.error("Delete Contact API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in deleteContactSaga:", error);
    }
}

// Update Notifaction Saga
function* updateContactSaga(action) {
    try {
        const response = yield call(updateContactAPI, action.payload);
        if (response) {
            yield put({ type: UPDATE_CONTACT_RED, data: action.payload });
        } else {
            console.error("Update Contact API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in updateContactSaga:", error);
    }
}

// Notifaction Saga (Watcher)
export function* contactSaga() {
    yield takeEvery(ADD_CONTACT, createContactSaga);
    yield takeEvery(GET_CONTACT, getContactSaga);
    yield takeEvery(DELETE_CONTACT, deleteContactSaga);
    yield takeEvery(UPDATE_CONTACT, updateContactSaga);
}
